/**
 * Dependancies
 * @ignore
 * @internal
 */
import { ReactElement, useState } from 'react'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'
import { makeStyles } from '@material-ui/core/styles'
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined'
import Dialog from '@material-ui/core/Dialog'
import IconButton from '@material-ui/core/IconButton'

/**
 * Styles
 * @ignore
 * @internal
 */
const useStyles = makeStyles(() => ({
  subtitle: {
  }
}))

/**
 * Types
 * @ignore
 * @internal
 */
interface InfoTitleProps {
  children?: null | Element | Element[] | string
  title?: null | string
  infoComponent?: (() => ReactElement) | null
}

/**
 * Information Title.
 *
 * @param props Component props.
 * @param props.title Title.
 * @param props.infoComponent Component to render for extra info.
 * @param props.children Child components.
 * @returns Info title recat component.
 */
const InfoTitle = ({ title = null, infoComponent = null, children = null }: InfoTitleProps): ReactElement => {
  const classes = useStyles()
  const Component = (infoComponent ?? (() => null))
  const [open, setOpen] = useState(false)

  return (
    <Box display="flex">
      <Box flexGrow={1}>
        <Typography variant="body1" color="textSecondary" className={classes.subtitle}>{title ?? children}</Typography>
      </Box>
      {Boolean(infoComponent) &&
        <Box>
          <IconButton size="small" onClick={() => setOpen(true)}>
            <InfoOutlinedIcon />
          </IconButton>
        </Box>
      }

      <Dialog open={open} onClose={() => setOpen(false)}>
        <Box p={2}>
          <Component />
        </Box>
      </Dialog>
    </Box>
  )
}

export default InfoTitle
